export const tabNames = {
  SEARCH: "SEARCH",
  SELECTED: "SELECTED",
  RELATED: "RELATED",
} as const;
